"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PubSubService = void 0;
var Logger_1 = __importDefault(require("../Core/Logger"));
var SessionBasedService_1 = require("./SessionBasedService");
var PubSubService = /** @class */ (function (_super) {
    __extends(PubSubService, _super);
    function PubSubService(endpoint, session) {
        var _this = _super.call(this, endpoint, session) || this;
        Logger_1.default.info('Attaching subscriptions to persistent connection..');
        if (_this.session.persistentConnection) {
            _this.attachSubscriptions();
            Logger_1.default.info('Persistent connection established successfully!');
        }
        return _this;
    }
    PubSubService.prototype.publish = function (ev, ackCallback) {
        this.session.persistentConnection.publish(ev, ackCallback.bind(this));
    };
    PubSubService.prototype.subscribeToEvent = function (eventType, handler) {
        this.session.persistentConnection.subscribe(eventType, handler.bind(this));
    };
    return PubSubService;
}(SessionBasedService_1.SessionBasedService));
exports.PubSubService = PubSubService;
//# sourceMappingURL=PubSubService.js.map